<template>
    <v-container fluid :class="$vuetify.breakpoint.smAndDown ? 'pa-0' : ''">
        <v-card
            :loading="isExporting || isLoadingInfo"
            style="width: 100% !important"
            :rounded="$vuetify.breakpoint.smAndDown ? '0' : '10'"
        >
            <v-card-title primary-title>
                <v-row justify="space-between">
                    <v-col cols="10">
                        <div
                            v-if="$vuetify.breakpoint.smAndDown"
                            class="primary--text text-overline ml-2"
                        >
                            <div class="d-flex">
                                Estadisticas por comercial
                                <a href="#finComercialesTable">
                                    <v-icon small color="primary" right
                                        >mdi-arrow-down-drop-circle</v-icon
                                    >
                                </a>
                            </div>
                            <small class="grey--text d-flex justify-start">{{
                                dateFilter.length != 0
                                    ? dateFilter.join(' - ')
                                    : defaultDate.join(' - ')
                            }}</small>
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            <div class="d-flex align-center">
                                <v-icon color="primary" left x-large>
                                    mdi-text-account
                                </v-icon>
                                Estadisticas por comercial
                            </div>
                            <small class="grey--text d-flex justify-start">{{
                                dateFilter.length != 0
                                    ? dateFilter.join(' - ')
                                    : defaultDate.join(' - ')
                            }}</small>
                        </div>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end align-center">
                        <Dial />
                    </v-col>
                </v-row>
            </v-card-title>

            <!-- <v-divider class="test"></v-divider> -->
            <v-card-text>
                <v-data-table
                    id="comercialesTable"
                    :search="search"
                    :headers="headers.filter(({ show }) => show)"
                    :items="comercialesInfo"
                    :footer-props="footerProps"
                    :items-per-page="comercialesInfo.length"
                    @click:row="showSingleView"
                    class="pa-0"
                >
                    <template v-slot:item.num_atenciones_vendidas="{ item }">
                        <v-chip
                            class="d-flex grow justify-center flex-wrap"
                            color="primary"
                            dark
                        >
                            {{ item.num_atenciones_vendidas }}
                        </v-chip>
                    </template>
                    <template slot="body.append">
                        <v-data-table
                            v-if="
                                $vuetify.breakpoint.xs && comercialesInfo.length
                            "
                            :headers="headers.filter(({ show }) => show)"
                            :items="[totalesResumen]"
                            disable-sort
                            hide-default-footer
                        >
                            <template v-slot:item.nombre>
                                <h2>Total</h2>
                            </template>
                            <template
                                v-slot:item.num_atenciones_vendidas="{ item }"
                            >
                                <v-chip
                                    class="d-flex grow justify-center flex-wrap"
                                    color="primary"
                                    dark
                                >
                                    {{ item.num_atenciones_vendidas }}
                                </v-chip>
                            </template>
                        </v-data-table>
                        <tr v-else-if="comercialesInfo.length">
                            <th v-if="isShowValueHeader('nombre')">
                                <h2>Total</h2>
                            </th>
                            <th v-if="isShowValueHeader('num_clientes')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_clientes }}
                                </h2>
                            </th>
                            <th
                                v-if="isShowValueHeader('num_clientes_creados')"
                            >
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_clientes_creados }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_atenciones')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_atenciones }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_agendados')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_agendados }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_gestiones')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_gestiones }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_no_contesta')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_no_contesta }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_no_interesado')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_no_interesado }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_ofertado')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_ofertado }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_rechazado')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_rechazado }}
                                </h2>
                            </th>
                            <th
                                v-if="isShowValueHeader('num_ofertas_vendidas')"
                            >
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_ofertas_vendidas }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_ofertas')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_ofertas }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_ventas')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_ventas }}
                                </h2>
                            </th>
                            <th v-if="isShowValueHeader('num_ventas_valor')">
                                <h2 class="d-flex justify-center">
                                    {{ totalesResumen.num_ventas_valor }}
                                </h2>
                            </th>
                            <th
                                v-if="
                                    isShowValueHeader('num_atenciones_vendidas')
                                "
                            >
                                <v-chip
                                    v-if="!$vuetify.breakpoint.smAndDown"
                                    class="d-flex grow justify-center flex-wrap"
                                    color="primary"
                                    dark
                                >
                                    <h2 class="d-flex justify-center">
                                        {{
                                            totalesResumen.num_atenciones_vendidas
                                        }}
                                    </h2>
                                </v-chip>
                            </th>
                        </tr>
                    </template>
                </v-data-table>
                <ModHeadersTable :headers="headers" />
                <Legend :items="legend" />
                <ComercialesTableFilterDialog
                    @dataDateComercialForm="onClickChild($event)"
                />
                <ComercialesTableSingleViewDialog />
            </v-card-text>
        </v-card>
        <div id="finComercialesTable"></div>
    </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Legend from '@/components/GerenciaTeletrabajo/ComercialesTable/Legend.vue';
import Dial from '@/components/GerenciaTeletrabajo/ComercialesTable/Dial.vue';
import ModHeadersTable from '@/components/GerenciaTeletrabajo/ComercialesTable/ModHeadersTable.vue';
import ComercialesTableFilterDialog from '@/components/GerenciaTeletrabajo/ComercialesTable/ComercialesTableFilterDialog.vue';
import ComercialesTableSingleViewDialog from '@/components/GerenciaTeletrabajo/ComercialesTable/SingleView/ComercialesTableSingleViewDialog.vue';
import { objectSnakeToCamelCase, firstAndLastOfMonth } from '@/util/libUtil.js';

export default {
    name: 'ComercialesTable',
    data: () => ({
        defaultDate: null,
        options: {},
        headers: [
            {
                text: 'Nombre',
                align: 'start',
                value: 'nombre',
                show: true,
            },
            {
                text: 'Clientes',
                value: 'num_clientes',
                align: 'center',
                show: true,
            },
            {
                text: 'Clientes creados',
                value: 'num_clientes_creados',
                align: 'center',
                show: true,
            },
            {
                text: 'Atenciones',
                value: 'num_atenciones',
                align: 'center',
                show: true,
            },
            {
                text: 'Agendados',
                value: 'num_agendados',
                align: 'center',
                show: true,
            },
            {
                text: 'Gestiones',
                value: 'num_gestiones',
                align: 'center',
                show: true,
            },

            {
                text: 'No contesta',
                value: 'num_no_contesta',
                align: 'center',
                show: true,
            },
            {
                text: 'No interesado',
                value: 'num_no_interesado',
                align: 'center',
                show: true,
            },
            // { text: 'No existe', value: 'num_no_existe', sortable: false },
            {
                text: 'Ofertado',
                value: 'num_ofertado',
                align: 'center',
                show: true,
            },
            {
                text: 'Rechazado',
                value: 'num_rechazado',
                align: 'center',
                show: true,
            },
            {
                text: 'Vendido',
                value: 'num_ofertas_vendidas',
                align: 'center',
                show: true,
            },
            {
                text: 'Total de ofertas',
                value: 'num_ofertas',
                align: 'center',
                show: true,
            },
            {
                text: 'Total de ventas',
                value: 'num_ventas',
                align: 'center',
                show: true,
            },
            {
                text: 'Ventas de valor',
                value: 'num_ventas_valor',
                align: 'center',
                show: true,
            },
            {
                text: 'Total atenciones vendidas',
                value: 'num_atenciones_vendidas',
                align: 'center',
                show: true,
            },
            // { text: 'Total venta valor', value: 'num_ventas_valor' },
            // { text: 'Total ventas', value: 'num_ventas', align: 'center' },
        ],
        legend: [
            {
                title: 'Clientes',
                icon: 'mdi-account',
                text: 'Número de clientes a los que se ha atendido',
            },
            {
                title: 'Clientes creados',
                icon: 'mdi-account-multiple-plus',
                text: 'Número de clientes creados',
            },
            {
                title: 'Atenciones',
                icon: 'mdi-account-plus',
                text: 'Número de atenciones realizadas',
            },
            {
                title: 'Agendado',
                icon: 'mdi-calendar-cursor',
                text: 'Número de gendaciones realizadas',
            },
            {
                title: 'Gestiones',
                icon: 'mdi-account-cog',
                text: 'Número de gestiones realizadas',
            },
            {
                title: 'No contesta',
                icon: 'mdi-phone-missed',
                text: 'Número de llamadas no contestadas',
            },
            {
                title: 'No interesado',
                icon: 'mdi-phone-cancel',
                text: 'Número de clientes no interesados',
            },
            {
                title: 'Ofertado',
                icon: 'mdi-offer',
                text: 'Número de ofertas realizadas',
            },
            {
                title: 'Rechazado',
                icon: 'mdi-close-circle',
                text: 'Número de ofertas rechazadas',
            },
            {
                title: 'Vendido',
                icon: 'mdi-account-cash',
                text: 'Número de ofertas vendidas',
            },
            {
                title: 'Total de ofertas',
                icon: 'mdi-sigma',
                text: 'Número de ofertas realizadas, suma de ofertado, rechazado y vendido',
            },
            {
                title: 'Total de ventas',
                icon: 'mdi-tag',
                text: 'Número de paquetes de las ofertas vendidas',
            },
            {
                title: 'Ventas valor',
                icon: 'mdi-flag',
                text: 'Número total de paquetes Fijos y Pospago vendidos',
            },
            {
                title: 'Total de atenciones vendidas',
                icon: 'mdi-flag-triangle',
                text: 'Número de ofertas vendidas y gestiones realizadas',
            },
        ],
        footerProps: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [20],
        },
    }),
    components: {
        Dial,
        ComercialesTableFilterDialog,
        ComercialesTableSingleViewDialog,
        Legend,
        ModHeadersTable,
    },
    computed: {
        totalesResumen() {
            if (this.comercialesInfo.length > 0) {
                const allowed = this.headers
                    .filter(({ show }) => show)
                    .map(({ value }) => value);

                let resumenTotales = {};

                this.comercialesInfo.forEach((obj) => {
                    Object.keys(obj).forEach((key) => {
                        if (allowed.includes(key)) {
                            if (resumenTotales[key]) {
                                resumenTotales[key] += obj[key];
                            } else {
                                resumenTotales[key] = obj[key];
                            }
                        }
                    });
                });

                return resumenTotales;
            } else {
                return [];
            }
        },
        dateFilter: {
            get() {
                return this.$store.state.gerencia.dateFilter;
            },
            set(val) {
                this.$store.commit('gerencia/dateFilter', val);
            },
        },
        selectedState: {
            get() {
                return this.$store.state.gerencia.selectedState;
            },
            set(val) {
                this.$store.commit('gerencia/selectedState', val);
            },
        },
        selectedTipoComercial: {
            get() {
                return this.$store.state.gerencia.selectedTipoComercial;
            },
            set(val) {
                this.$store.commit('gerencia/selectedTipoComercial', val);
            },
        },
        ...mapState('gerencia', {
            comercialesInfo: (state) => state.comercialesInfo,
            isLoadingInfo: (state) => state.isLoadingInfo,
        }),
        ...mapState('util', {
            isExporting: (state) => state.isExporting,
            search: (state) => state.navBarSearchField,
        }),
    },
    methods: {
        onClickChild({ dateFilter, stateComercial, selectedTipoComercial }) {
            this.dateFilter = dateFilter;
            this.selectedState = stateComercial;
            this.selectedTipoComercial = selectedTipoComercial;
            this.getComercialesData({});
        },
        isShowValueHeader(item) {
            return this.headers.find(({ value }) => value === item).show;
        },
        showSingleView(item) {
            let params = {
                comercial: item.id,
                updated_on: this.dateFilter,
                itemsPerPage: 10,
                page: 1,
            };

            this.$store.commit('gerencia/currentComercial', item);
            this.$store.commit(
                'teletrabajo/Comerciales',
                objectSnakeToCamelCase(this.$store.state.gerencia.comerciales)
            );
            this.$store.dispatch('gerencia/fetchAtenciones', params);
            this.$store.commit('gerencia/singleViewDialog', true);
        },
        ...mapActions('gerencia', ['getComercialesData']),
    },
    watch: {
        comercialesInfo() {
            this.footerProps.itemsPerPageOptions = [
                this.comercialesInfo.length + 1,
            ];
        },
    },
    beforeMount() {
        // Para poner por defecto la fecha del mes actual
        this.defaultDate = firstAndLastOfMonth();
        this.getComercialesData({});
    },
    beforeDestroy() {
        this.$store.commit('gerencia/dateFilter', []);
        this.$store.commit('gerencia/selectedState', 'ALTA');
    },
};
</script>

<style scoped>
</style>